//components
import Footer from "../components/footer.js";
import {HideAt, ShowAt } from 'react-hide-show-utils';

//styling
import '../app/App.css';
import 'typeface-lato';

//images
import GameplayGif from '../assets/images/how-to-play/GameplayGif.gif';
import Gameplay from '../assets/images/how-to-play/GameplayLarge.png';
import BobaMachineLocation from '../assets/images/how-to-play/BobaMachineLocation.svg';

const HowToPlay = () => {
    return (
        <div className="centered" style={{backgroundColor: "#FFFBF3" , height: "100%", paddingBottom: "70px"}}>
            <h1 className="skinny-header-text"><br />How to Play</h1>

            <div className="body-section">
                <h2 className="body-text" style={{fontWeight: 700}}>
                    Match 3 ingredients to collect them!
                </h2>
                <img src={GameplayGif} alt="Gameplay Gif" className="image"/>
            </div>

            <div className="body-section">
                <p className="body-text">
                    On the top right corner, you'll see the list of ingredients you'll need to collect
                    to win this stage and the number of times you'll need to complete it.<br /><br />
                    Keep an eye out for the number of moves you have left! Once you've run out,
                    the game ends.
                </p>
                <img src={Gameplay} alt="Gameplay" className="image"/>
            </div>
                
            <div className="centered how-to-claim-container" 
                 style={{backgroundColor: "#FEECC4", width: "95vw", height: "100%",
                         borderRadius: 40, paddingTop: "2%", marginTop: "8vh"}}>
                <h1 className="header-text">How to Claim Your Rewards</h1>
                <p className="body-text">
                    After you've claimed a reward and ordered your drink or food on the app,
                    you'll receive a confirmation email. At the local business of your choice,
                    show them the email and viola, you have your order!!<br /><br />
                    If you're simply craving a cup of boba, you can also claim your rewards at
                    our vending machine.
                </p>
                <HideAt breakpoint="(min-width: 1024px)">
                    <img src={BobaMachineLocation} alt="Takena Hall, Ellingson Rd. SW, albany, OR 97321" 
                         style={{width: "80%", marginBottom: "8vh"}}/>
                </HideAt>
                <ShowAt breakpoint="(min-width: 1024px)">
                    <img src={BobaMachineLocation} alt="Takena Hall, Ellingson Rd. SW, albany, OR 97321" 
                         style={{marginBottom: "8vh"}}/>
                </ShowAt>
            </div>
            {<Footer />}
        </div>
    )
}

export default HowToPlay;